import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import useAacFlags from "hooks/useAacFlags";
import { hasAtLeastOneRequiredAction } from "utils/access";
import { hasSpaceManageAccess } from "utils/user";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AccountContext } from "views/AccountWrapper";
import { Space } from "types/generated";
import {
  CONTEXT_CREATE_ACCESS_TYPES,
  CONTEXT_CREATE_ACCESS_TYPES_V2,
} from "shared/Context/access/useCanCreateContext";
import useTypedFlags from "hooks/useTypedFlags";

const useContextAvailableSpaces = (): Space[] => {
  const { spaces } = useTypedContext(SpacesContext);
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useAacFlags();
  const { customAccessRolesV2 } = useTypedFlags();

  const availableSpaces = useMemo(() => {
    return spaces?.filter((space) => {
      if (customAccessRolesV2) {
        return hasAtLeastOneRequiredAction(CONTEXT_CREATE_ACCESS_TYPES_V2, viewer, space.id);
      } else if (customAccessRoles) {
        return hasAtLeastOneRequiredAction(CONTEXT_CREATE_ACCESS_TYPES, viewer, space.id);
      } else {
        return hasSpaceManageAccess(space.accessLevel);
      }
    });
  }, [spaces, viewer, customAccessRoles, customAccessRolesV2]);

  return availableSpaces || [];
};

export default useContextAvailableSpaces;
